module.exports = __webpack_public_path__ + "static/media/home_pg_new_block.a6c90cbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_pg_new_block.png
// module id = 1318
// module chunks = 0